import React from 'react';
import styled from 'styled-components';

import theme from '../../constants/AppTheme';
import Txt from '../atoms/Txt';
import { deleteProduct } from '../../database/repositories/ProductRepository';
import { normalizeMoney } from '../../utils/util';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 250px;
  margin: 10px;
`;

const Cover = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 10px;
`;

const PriceTagWrapper = styled.div`
  text-align: right;
  margin-top: -35px;
`;

const PriceTag = styled.span`
  background-color: ${theme.yellow};
  border-radius: 10px;
  padding: 10px 15px;
`;

const TextWrapper = styled.div`
  padding: 10px 5px;
  display: flex;
  flex-direction: column;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Button = styled.button`
  border: none;
  border-radius: 10px;
  background-color: ${theme.red};
  padding: 5px 15px;
`;

function ShowcaseCard({ data, style, ...props }) {
  return (
    <Container>
      <Cover src={data.pictures[0]} alt="" />
      <PriceTagWrapper>
        <PriceTag>
          <Txt color="white" bold>
            {normalizeMoney(data.price)}
          </Txt>
        </PriceTag>
      </PriceTagWrapper>
      <TextWrapper>
        <Txt color={theme.blue}>{data.name}</Txt>
        <Txt size={14} color={theme.brightGreen}>
          {' '}
          &bull; Anuncio online
        </Txt>
      </TextWrapper>
      <ButtonsWrapper>
        <Button>
          <Txt color="white" href={`/produto/cadastro?productID=${data.id}`}>
            Editar
          </Txt>
        </Button>
        <Button onClick={() => deleteProduct(data.id)}>
          <Txt color="white">Excluir</Txt>
        </Button>
      </ButtonsWrapper>
    </Container>
  );
}

export default ShowcaseCard;
